import { observer } from 'mobx-react-lite';

import { cn } from '@/lib/utils';
import { uiStore } from '@/stores/ui.store';

import { useBirdCanvas } from './agents-bird.hooks';
import { BIRD_INK, type BirdActivity, type BirdLook } from './agents-bird.look';

const ACTIVITY_STATUS: Partial<Record<BirdActivity, string>> = {
  thinking: 'is thinking',
  working: 'is working',
  waiting: 'has a reply',
  error: 'ran into a problem',
};

type AgentAvatarProps = {
  bird: BirdLook;
  activity?: BirdActivity;
  hatch?: boolean;
  statusName?: string;
  className?: string;
};

export const AgentAvatar = observer(
  ({
    bird,
    activity = 'idle',
    hatch = false,
    statusName,
    className,
  }: AgentAvatarProps) => {
    const dark = uiStore.theme === 'dark';
    const { canvasRef, hostRef } = useBirdCanvas({
      species: bird.species,
      color: BIRD_INK[bird.plumage][dark ? 'dark' : 'light'],
      activity,
      dark,
      hatch,
    });
    const status = ACTIVITY_STATUS[activity];
    return (
      <span
        ref={hostRef}
        className={cn('relative block size-9 shrink-0', className)}
      >
        <canvas
          ref={canvasRef}
          aria-hidden
          className="pointer-events-none absolute -left-[10%] -top-[10%] size-[120%]"
        />
        {statusName !== undefined && (
          <span role="status" className="sr-only">
            {status ? `${statusName} ${status}` : ''}
          </span>
        )}
      </span>
    );
  }
);
